import React, { useState, useEffect } from "react";
import { User } from "../../model/User";
import { getAxios } from "../../utils/endpoints";
import { SelectChangeEvent } from "@mui/material";

interface IState {
    transferSet: string;
    transferText: string;
    scheduleText: string;
    timeZone: string;
    promotion: string;
    demo: string;
    priceLock: string;
    warranty: string;
    installerInfo: string;
    showroomAddress: string;
    dealerPhone: string;
    website: string;
    comments: string;
    emailDealer: string;
    callCenterHours: string;
    businessName: string;
}

export const useEditDealerInfo = (username?: string) => {
    const user: User = new User();

    const selectedUsername: string = username ? username : user.UserName;

    const [state, setState] = useState<IState>({
        businessName: "",
        callCenterHours: "",
        comments: "",
        dealerPhone: "",
        demo: "",
        emailDealer: "",
        installerInfo: "",
        priceLock: "",
        promotion: "",
        scheduleText: "",
        showroomAddress: "",
        timeZone: "",
        transferSet: "",
        transferText: "",
        warranty: "",
        website: ""
    });

    const [snackbarState, setSnackbarState] = useState({
        message: "",
        level: "",
        isOpen: false
    });

    const onChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value } = event.target;
    
        setState((prevState) => ({
            ...prevState,
            [name]: value
        }));
    }

    const onChangeSelect = (event: SelectChangeEvent<unknown>) => {
        const { name, value } = event.target;
    
        setState((prevState) => ({
            ...prevState,
            [name]: value
        }));
    }

    const onFetchDealerInfo = async (): Promise<void> => {
        const response = await getAxios(`/profile/dealer-info/${selectedUsername}`, "GET");

        const data = await response.data;

        setState({
            transferSet: data.dinWarmTXorSetAppt,
            transferText: data.dinWarmTXPhone,
            scheduleText: data.dinDateTimesToSet,
            timeZone: data.dinTimezone,
            promotion: data.dinPromotion,
            demo: data.dinDemoInfo1,
            priceLock: data.dinDemoInfo2,
            warranty: data.dinDemoInfo3,
            installerInfo: data.dinInstallerInfo,
            showroomAddress: data.dinShowroomAddress,
            dealerPhone: data.dinDealerPhone,
            website: data.dinWebsite,
            comments: data.dinComments,
            emailDealer: data.dinEmailDealer,
            callCenterHours: data.dinCallCenterHours,
            businessName: data.dinBusinessName
        })
    }

    const onUpdateDealerInfo = async (): Promise<void> => {
        try {
            const response = await getAxios(`/profile/dealer-info/${selectedUsername}`, "PUT", {
                dinWarmTXorSetAppt: state.transferSet,
                dinWarmTXPhone: state.transferText,
                dinDateTimesToSet: state.scheduleText,
                dinTimezone: state.timeZone,
                dinPromotion: state.promotion,
                dinDemoInfo1: state.demo,
                dinDemoInfo2: state.priceLock,
                dinDemoInfo3: state.warranty,
                dinInstallerInfo: state.installerInfo,
                dinShowroomAddress: state.showroomAddress,
                dinDealerPhone: state.dealerPhone,
                dinWebsite: state.website,
                dinComments: state.comments,
                dinEmailDealer: parseInt(state.emailDealer),
                dinCallCenterHours: state.callCenterHours,
                dinBusinessName: state.businessName,
            });
            
            setSnackbarState({ message: "Dealer information has been updated",  level: "success", isOpen: true });
        } catch (error) {
            console.error(error);
            setSnackbarState({ message: "Something went wrong",  level: "error", isOpen: true });
        }
    }

    const onCloseSnackbar = () => {
        setSnackbarState((prevState) => ({
            ...prevState,
            isOpen: false
        }));
    }

    useEffect(() => {
        onFetchDealerInfo();
    }, [])

    return {
        state,
        snackbarState,
        onChange,
        onCloseSnackbar,
        onChangeSelect,
        onUpdateDealerInfo
    }
}